var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "deep-steps", class: { expanded: _vm.isExpanded } },
    [
      _c(
        "div",
        {
          staticClass: "deep-steps-header",
          on: {
            click: function ($event) {
              _vm.expanded = !_vm.isExpanded
            },
          },
        },
        [
          _c("i", {
            class: _vm.live ? "fas fa-spinner fa-spin" : "fas fa-microscope",
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.label) + " (" + _vm._s(_vm.steps.length) + ")"),
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-chevron-right deep-steps-chevron" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "deep-steps-list" },
        _vm._l(_vm.steps, function (step) {
          return _c("li", { key: step.index, class: "is-" + step.status }, [
            _c("i", { class: _vm.iconFor(step) }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(step.intent || step.tool))]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }